import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export const classes: Record<string, SystemStyleObject<Theme>> = {
  tagPopup: {
    background: "#4ec2fd",
    color: "#000000",
    padding: { sm: "16px 32px", xs: "8px 16px" },
    display: "flex",
    fontSize: "12px",
    borderRadius: "24px",
    gap: ({ spacing }) => ({ xs: spacing(1), sm: spacing(2) }),
    maxWidth: { xs: "100%", sm: "410px" },
    border: ({ palette }) => `1px solid ${palette.tagBorder.primary}`,
    textAlign: "initial",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    gap: ({ spacing }) => spacing(2),
    marginBottom: ({ spacing }) => spacing(1),
  },

  title: {
    fontSize: "14px",
    fontWeight: 600,
  },

  tagIcon: {
    fontSize: ({ spacing }) => spacing(10),
  },

  closeIcon: {
    marginRight: { sm: "-24px", xs: 0 },
    cursor: "pointer",
  },

  actions: {
    marginTop: ({ spacing }) => spacing(2),
    ".MuiButton-root": {
      borderRadius: "8px",
      padding: "4px 16px",
    },

    ".MuiButton-contained": {
      backgroundColor: "#000",
      color: "#fff",
      "&:hover": {
        backgroundColor: "primary.dark",
        color: ({ palette }) => palette.dark.tertiary,
      },
    },

    ".MuiButton-outlined": {
      borderColor: "#000",
    },
  },
};
